import { render, staticRenderFns } from "./PostThread.vue?vue&type=template&id=a1574b7a&scoped=true"
import script from "./PostThread.vue?vue&type=script&lang=js"
export * from "./PostThread.vue?vue&type=script&lang=js"
import style0 from "./PostThread.vue?vue&type=style&index=0&id=a1574b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1574b7a",
  null
  
)

export default component.exports